// src/belediye/utils/authzStorage.js
//
// authz durumu için localStorage köprüsü (FAZ-12).
// Hem authzSlice (hydrate/persist) hem belediyeApi 403 interceptor'ı
// (React dışı uiOn okuması) bu modülü kullanır — döngüsel import yok.

export const AUTHZ_LS_KEY = "authz_v1";

export const EMPTY_AUTHZ = Object.freeze({
  permissions: [],
  scope: null,
  globalRole: null,
  enabledModules: {},
  enabledFeatures: {}, // FAZ-37 — mesajlaşma özellik-flag'leri (/me.enabled_features)
  activeUnit: null,
  isSuperUser: false,
  uiProfile: null, // FAZ-17 — sunum profili (yalnız görünüm; yetkiye etkisi yok)
  status: "empty", // "empty" | "loaded"
});

export function readAuthzFromStorage() {
  try {
    const raw = window.localStorage.getItem(AUTHZ_LS_KEY);
    if (!raw) return { ...EMPTY_AUTHZ };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !Array.isArray(parsed.permissions)) {
      window.localStorage.removeItem(AUTHZ_LS_KEY);
      return { ...EMPTY_AUTHZ };
    }
    return {
      ...EMPTY_AUTHZ,
      ...parsed,
      permissions: parsed.permissions.filter((p) => typeof p === "string"),
      enabledModules:
        parsed.enabledModules && typeof parsed.enabledModules === "object"
          ? parsed.enabledModules
          : {},
      enabledFeatures:
        parsed.enabledFeatures && typeof parsed.enabledFeatures === "object"
          ? parsed.enabledFeatures
          : {},
      status: "loaded",
    };
  } catch {
    try {
      window.localStorage.removeItem(AUTHZ_LS_KEY);
    } catch {
      /* storage erişilemez — sessiz */
    }
    return { ...EMPTY_AUTHZ };
  }
}

export function writeAuthzToStorage(state) {
  try {
    window.localStorage.setItem(
      AUTHZ_LS_KEY,
      JSON.stringify({
        permissions: state.permissions,
        scope: state.scope,
        globalRole: state.globalRole,
        enabledModules: state.enabledModules,
        enabledFeatures: state.enabledFeatures,
        activeUnit: state.activeUnit,
        isSuperUser: state.isSuperUser,
        uiProfile: state.uiProfile ?? null,
      })
    );
  } catch {
    /* quota/priv mode — persist olmadan da çalışır */
  }
}

export function clearAuthzStorage() {
  try {
    window.localStorage.removeItem(AUTHZ_LS_KEY);
  } catch {
    /* sessiz */
  }
}

/**
 * uiOn ÇİFT EMNİYETİ (FAZ-12 MD 2.1): permission_ui şalteri AÇIK VE
 * permissions dolu olmalı — şalter açık ama izinler boş/gelmemişse eski yol
 * ("bomboş sidebar" yapısal olarak imkânsız).
 */
export function computeUiOn(enabledModules, permissions) {
  return (
    !!enabledModules &&
    enabledModules.permission_ui === true &&
    Array.isArray(permissions) &&
    permissions.length > 0
  );
}

/** React dışı bağlamlar için (axios interceptor): storage'dan uiOn. */
export function readUiOnFromStorage() {
  const s = readAuthzFromStorage();
  return computeUiOn(s.enabledModules, s.permissions);
}
